import { ConfirmModal } from 'components/modal/ConfirmModal';
import { Pagination } from 'components/pagination/Pagination';
import { SubTitle } from 'components/text/SubTitle';
import { Typography, closeModal, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { Grid_3 } from 'modules/dashboard/styles/lesson';

import { isEmpty } from 'lodash';

import { TABLE_KEY } from 'constants/table';

import { CardItem } from '../components/CardItem';
import { Header } from '../components/Header';
import { useCoursesController } from '../core/controller/courses';
import { useLibrary } from '../core/hook';

export const CoursesPage = () => {
  const {
    coursesData,
    queryState,
    total,
    selectedCourses,
    setSelectedCourses,
    onChangeSelectedCourses,
    searchCourse,
    onChangeSearchCourse,
    goToCourseDetail,
    handleEditCourse,
    handleDeleteCourse,
    onDeleteCourse,
    handleDelete,
    handleDuplicateCourse,
  } = useCoursesController();

  const { onClickAddItem } = useLibrary();

  const selectedCoursesTotal = Object.keys(selectedCourses).length;

  const showCheckbox = !isEmpty(Object.keys(selectedCourses));

  const renderListLesson = () => {
    return (
      <>
        <Grid_3>
          {coursesData.map((el, index) => {
            const selected = Boolean(selectedCourses[el.id]);

            return (
              <CardItem
                key={index}
                selected={selected}
                onChange={onChangeSelectedCourses(el.id)}
                goToDetailPage={() => goToCourseDetail(el.id)}
                handleEdit={() => handleEditCourse(el.id)}
                handleDelete={() => handleDeleteCourse(el.id)}
                handleDuplicate={() => handleDuplicateCourse(el.id)}
                hideAction={false}
                name={el.name}
                id={el.id}
                thumbnail={el?.thumbnail ?? ''}
                subTitle={
                  <SubTitle
                    leftTitle={`${el.totalLessons ?? 0} ${Number(el.totalLessons) > 1 ? 'lessons' : 'lesson'}`}
                    rightTitle={`${el.totalAssessments ?? 0} ${Number(el.totalAssessments) > 1 ? 'assessments' : 'assessment'}`}
                  />
                }
                showCheckbox={showCheckbox}
              />
            );
          })}
        </Grid_3>
        <Pagination total={total.value} queryState={queryState} tableKey={TABLE_KEY.COURSES} />
      </>
    );
  };

  return (
    <div>
      <Header
        selected={selectedCourses}
        options={coursesData}
        setSelected={setSelectedCourses}
        onDelete={() => openModal(MODAL_KEY.DELETE_COURSE)}
        type="course"
        searchValue={searchCourse.value}
        onChangeSearch={onChangeSearchCourse}
        onClickAddItem={onClickAddItem}
      />
      {coursesData.length > 0 ? (
        renderListLesson()
      ) : (
        <Typography
          variant="h3"
          weight={700}
          style={{ textAlign: 'center', justifyContent: 'center', marginTop: 30 }}
        >
          No data
        </Typography>
      )}

      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_COURSE}
        content={`Delete these ${selectedCoursesTotal === 0 ? '' : selectedCoursesTotal} courses.`}
        header={`Delete ${selectedCoursesTotal === 0 ? '' : selectedCoursesTotal} courses`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_COURSE)}
        onSubmit={() => {
          isEmpty(selectedCourses) ? onDeleteCourse() : handleDelete();
          closeModal(MODAL_KEY.DELETE_COURSE);
        }}
      />
    </div>
  );
};
